import { gql } from '@apollo/client';

export const UPDATE_PATIENT_ADDRESS = gql`
  mutation UpdateAddress($data: UpdatePatientAddressInput!) {
    updatePatientAddress(data: $data)
  }
`;
